import { primaryColor } from 'assets/jss/material-dashboard-pro-react';
import { hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const excelPreviewStyle = (theme) => ({
	tableWrapper: {
		margin: '0px 58px 29px 58px',
	},
	rightFlex: {
		marginLeft: 'auto',
	},
	uploadedFilesRow: {
		marginTop: '10px',
		display: 'flex',
		flexDirection: 'row',
		'& :nth-last-child(1)': {
			marginLeft: 'auto',
		},
	},
	fileIcon: {
		fontSize: '18px',
		marginRight: '6px',
	},
	uploadedFilesHeadingRow: {
		marginTop: '20px',
		display: 'flex',
		flexDirection: 'row',
		'& :nth-last-child(1)': {
			marginLeft: 'auto',
		},
	},
	downloadLink: {
		cursor: 'pointer',
		color: primaryColor[0],
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& svg': {
			position: 'relative',
			bottom: '2px',
			marginRight: '4px',
		},
		'& :hover': {
			color: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.88)`,
		},
	},
});

export default excelPreviewStyle;
